import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCurrentStation = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M16 4C22.6274 4 28 9.37258 28 16C28 22.6274 22.6274 28 16 28C9.37258 28 4 22.6274 4 16C4 9.37258 9.37258 4 16 4ZM16 6.7998C10.919 6.7998 6.7998 10.919 6.7998 16C6.7998 21.081 10.919 25.2002 16 25.2002C21.081 25.2002 25.2002 21.081 25.2002 16C25.2002 10.919 21.081 6.7998 16 6.7998ZM16 9.60059C19.5346 9.6006 22.4003 12.4654 22.4004 16C22.4004 19.5346 19.5346 22.4004 16 22.4004C12.4654 22.4004 9.59961 19.5346 9.59961 16C9.59966 12.4654 12.4654 9.60059 16 9.60059Z" })
});
export default SvgCurrentStation;
